import React from 'react';
import { PreferenceProvider } from './preferenceProvider';
import { ToastProvider } from './toastProvider';
import { ConfigProvider, useConfig } from './configProvider';
import ErrorProvider from '../providers/ErrorProvider';

const InnerProviders = ({ children }) => {
  const { config } = useConfig();
  const userId = config?.user?.id || null;

  return (
    <PreferenceProvider userId={userId}>
      <ToastProvider>{children}</ToastProvider>
    </PreferenceProvider>
  );
};

const Providers = ({ children }) => (
  <ErrorProvider>
    <ConfigProvider>
      <InnerProviders>{children}</InnerProviders>
    </ConfigProvider>
  </ErrorProvider>
);

export default Providers;
